module.exports = __webpack_public_path__ + "img/2.9924d80b.png";